"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minicartReducer = void 0;
const equals_1 = __importDefault(require("ramda/src/equals"));
const reject_1 = __importDefault(require("ramda/src/reject"));
const ts_pattern_1 = require("ts-pattern");
const state_1 = require("../../redux/state");
const utils_1 = require("../../redux/utils");
const minicartReducer = (state) => (action) => (0, ts_pattern_1.match)(action)
    .with({ type: 'SET_MINICART_LOADING' }, _action => state.update(state_1.stateKeys.minicart, _state => ({
    ..._state,
    loading: _action.payload
})))
    .with({ type: 'INITIALIZE_MINICART' }, _action => state.update(state_1.stateKeys.minicart, _state => (0, utils_1.returnStateLoadingFalse)(_state, _action)))
    .with({ type: 'INITIALIZE_MINICART_ERROR' }, _action => state.update(state_1.stateKeys.minicart, _state => ({
    ..._state,
    error: _action.payload,
    loading: false
})))
    .with({ type: 'REMOVE_ITEM_FROM_MINICART' }, _action => state.update(state_1.stateKeys.minicart, _state => {
    const payloadSku = _action.payload;
    // TODO figure out what is wrong with this type
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const newValue = (0, reject_1.default)(
    // TODO: this seems like it should just look at the object key, since it's just the master sku
    ({ masterSku }) => (0, equals_1.default)(masterSku, payloadSku))(_state.value); // TODO: fix this type
    return ({
        ..._state,
        value: { ...newValue }
    });
}))
    .with({ type: 'UPDATE_MINICART' }, _action => state.update(state_1.stateKeys.minicart, _state => ({
    ..._state,
    value: {
        ..._state.value,
        ..._action.payload
    }
})))
    .exhaustive();
exports.minicartReducer = minicartReducer;
//# sourceMappingURL=reducer.js.map